import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-notification-card',
    templateUrl: './notification-card.component.html',
    styleUrls: ['./notification-card.component.scss'],
    standalone: false
})
export class NotificationCardComponent {
  @Input() dailyData: any;
}
